/*
 * Dutch retail convention: a whole-euro price like "€31,00" is usually
 * written "€31,-" instead. Applied sitewide (cart, cart drawer, every
 * product template, collection cards) by targeting the theme's own money
 * markup rather than editing every Liquid file that renders a price - the
 * `money` filter is called in dozens of places, but almost all of them wrap
 * the output in the same ".amount" span (product-price.liquid, cart.liquid,
 * cart-drawer.liquid); a few of this redesign template's own custom
 * elements don't use that wrapper, so they're listed explicitly too.
 *
 * A MutationObserver keeps this correct after cart drawer refreshes, variant
 * price swaps, bundle recalculation, etc. - anything that replaces price
 * markup via innerHTML after the initial page load - without needing to
 * hook into each of those mechanisms individually.
 */
(function () {
  var MONEY_SELECTOR = '.amount, .product-bundle--price, .product-bundle--total-price, .product-also-bought--price, .single-add-to-cart-button--price';
  var WHOLE_EURO_PATTERN = /(\d),00(?!\d)/g;

  function applyTo(el) {
    var updated = el.textContent.replace(WHOLE_EURO_PATTERN, '$1,-');
    if (updated !== el.textContent) el.textContent = updated;
  }

  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches(MONEY_SELECTOR)) applyTo(root);
    if (root.querySelectorAll) {
      root.querySelectorAll(MONEY_SELECTOR).forEach(applyTo);
    }
  }

  scan(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(scan);
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
